// url前缀
export const API_URL = 'http://device.dcloud.yunku.live/api/open/';
export const BASE_URL = 'http://device.dcloud.yunku.live/';
// export const API_URL = 'http://18.142.9.29:8041/api/open/';
// export const BASE_URL = 'http://18.142.9.29:8041/';